import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import './app.css';
import { Header } from './components/header';
import { Box, Grid } from '@mui/material';
import { LoginPage } from './pages/loginPage';
import { DashboardPage } from './pages/dashboard/dashboardPage';
import { OrganizationListPage } from './pages/organizationListPage';
import { ProductPage } from './pages/dashboard/client/products/productPage';
import { AppUserContext } from './context/appUserContext';
import { UserItem } from './api/models/schema';
import { getCookie } from 'cookies-next';
import { set } from 'react-hook-form';

export function App() {

  const [userData, setUserData] = useState<UserItem | undefined>(undefined);

  useEffect(() => {
    refreshUser();
  }, []);

  function refreshUser() {
    const user = getCookie("userData") as string;
    if (user) {
      setUserData(JSON.parse(user));
    } 
    else{
      setUserData(undefined);
    }
  }

  return (
   <>
   <BrowserRouter>
   <AppUserContext.Provider value={{appUser: userData, refreshUser:refreshUser}}>
   <Header />
   <Box className='mainContent'>
        <Grid container spacing={2}>
          <Grid item xs={1} />

          <Grid item xs={10} >
            
              <Routes>
                <Route path='/' element={<LoginPage />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/dashboard/:orgId' element={<DashboardPage />} />
                <Route path='/organizations' element={<OrganizationListPage />} />
                <Route path='/organization/:orgId/products' element={<ProductPage />} />
              </Routes>
            
          </Grid>

          <Grid item xs={1} />
        </Grid>
      </Box>
      </AppUserContext.Provider>
      </BrowserRouter>
   </>
  );
}